var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-fit"},[_c('h3',{staticClass:" px-4 py-3 bg-white inline-block uppercase text-gray-600 text-sm w-fit"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }